import 'css-chunksrc/client/common/projectsSelection/input/nameWithCount/styles.scss';export default {
  "name": "_name_xzace_1",
  "nameWithCount": "_nameWithCount_xzace_8",
  "count": "_count_xzace_19"
};